<div
  class="mainContainer d-flex flex-column align-items-center w-100 position-relative mb-5 inshight_backdrop"
>
  <h2 class="headingBL">Virsa <span> Insights</span></h2>
  <p class="Insight_detail vtext">
    Discover life-changing experiences at Virsa. Our live activities, flexible
    access, and expert trainers elevate personal growth. Access India's premier
    Performing Arts Program for skill mastery and enrichment. Explore Virsa
    Insights for a richer life.
  </p>
  <div class="Card_container">
    <div
      class="d-flex flex-column align-items-center insightCard flex-wrap"
      *ngFor="let insight of insight"
    >
      <img
        loading="lazy"
        class="cardImage"
        [src]="insight.image"
        alt="Card_Image"
      />
      <div class="card-content">
        <h4 class="headingBL smallHeading">
          {{ insight.name1 }}<span>{{ insight.name2 }}</span>
        </h4>
        <p class="mt-4 headDetails">
          {{ insight.details }}
        </p>
      </div>
    </div>
  </div>
</div>
